var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcFaceSmillingGrey = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47778 20 0 15.5228 0 10C0 4.47778 4.47778 0 10 0C15.5228 0 20 4.47778 20 10Z",
    fill: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8095 9.88733C15.7761 9.81233 14.9767 8.05566 13.3334 8.05566C11.6906 8.05566 10.8906 9.81233 10.8572 9.88733C10.8061 10.0023 10.8395 10.1368 10.9378 10.2157C11.035 10.2946 11.1745 10.2973 11.2767 10.2234C11.2834 10.2184 11.9778 9.72233 13.3334 9.72233C14.6811 9.72233 15.3745 10.2118 15.39 10.2229C15.4389 10.2596 15.4978 10.2779 15.5556 10.2779C15.6167 10.2779 15.6784 10.2573 15.7289 10.2173C15.8272 10.1384 15.8611 10.0029 15.8095 9.88733ZM9.14281 9.88733C9.10947 9.81233 8.31003 8.05566 6.66669 8.05566C5.02392 8.05566 4.22392 9.81233 4.19058 9.88733C4.13947 10.0023 4.1728 10.1368 4.27058 10.2157C4.36836 10.2946 4.5078 10.2973 4.60947 10.2234C4.61669 10.2184 5.31058 9.72233 6.66669 9.72233C8.01447 9.72233 8.7078 10.2118 8.72336 10.2229C8.77225 10.2596 8.83114 10.2779 8.88892 10.2779C8.95003 10.2779 9.01169 10.2573 9.06225 10.2173C9.16114 10.1384 9.19392 10.0029 9.14281 9.88733ZM10 12.2223C7.98725 12.2223 6.65169 11.9879 5.00003 11.6668C4.6228 11.594 3.88892 11.6668 3.88892 12.7779C3.88892 15.0001 6.44169 17.7779 10 17.7779C13.5578 17.7779 16.1111 15.0001 16.1111 12.7779C16.1111 11.6668 15.3772 11.5934 15 11.6668C13.3484 11.9879 12.0128 12.2223 10 12.2223Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.7773C5 12.7773 6.66667 13.3329 10 13.3329C13.3333 13.3329 15 12.7773 15 12.7773C15 12.7773 13.8889 14.9996 10 14.9996C6.11111 14.9996 5 12.7773 5 12.7773Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcFaceSmillingGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-face-smilling-grey.a5b67eba0639136aba4a7706a0fcc9d3.svg";